import { render } from "./TodayProductDetail.vue?vue&type=template&id=137fa510&scoped=true"
import script from "./TodayProductDetail.vue?vue&type=script&lang=js"
export * from "./TodayProductDetail.vue?vue&type=script&lang=js"

import "./TodayProductDetail.vue?vue&type=style&index=0&id=137fa510&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137fa510"]])

export default __exports__